import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import i18n from '../i18n'
import { signOut } from '../slices/auth'
import { setLanguage } from '../slices/config'
import type { RootState } from '../store'
import {
  IconBell,
  IconChevron,
  IconInfo,
  IconLang,
  IconLogout,
  IconShare,
  IconSupport,
  IconUser,
} from '../components/Icons'
import './Settings.css'

export function SettingsPage() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useSelector((s: RootState) => s.auth.user)
  const lang = useSelector((s: RootState) => s.config.selectedLanguage)

  const rows = [
    {
      icon: <IconUser size={22} />,
      title: t('Profil'),
      sub: `${user?.email ?? ''}`,
    },
    {
      icon: <IconBell size={22} />,
      title: t('Notifications'),
      sub: t('Gérer les alertes'),
    },
    {
      icon: <IconSupport size={22} />,
      title: t('Support'),
      sub: 'contact@omnivatis.com',
    },
    {
      icon: <IconLang size={22} />,
      title: t('Langue'),
      sub: lang === 'fr' ? 'Français' : 'English',
      action: 'lang' as const,
    },
    {
      icon: <IconShare size={22} />,
      title: t('Partager l’application'),
      sub: 'DriveOps',
    },
    {
      icon: <IconInfo size={22} />,
      title: t('À propos'),
      sub: 'DriveOps Web',
      action: 'about' as const,
    },
  ]

  return (
    <div className="settings">
      <div className="settings__list">
        {rows.map((row) => (
          <div key={row.title} className="settings__item">
            <span className="settings__ico">{row.icon}</span>
            <div className="settings__copy">
              <strong>{row.title}</strong>
              <span>{row.sub}</span>
              {row.action === 'lang' && (
                <div className="mob-toggle settings__lang">
                  {(['fr', 'en'] as const).map((code) => (
                    <button
                      key={code}
                      type="button"
                      className={lang === code ? 'is-on' : undefined}
                      onClick={() => {
                        dispatch(setLanguage(code))
                        void i18n.changeLanguage(code)
                      }}
                    >
                      {code.toUpperCase()}
                    </button>
                  ))}
                </div>
              )}
              {row.action === 'about' && (
                <p className="settings__links">
                  <a href="http://driveops.omnivatis.com/privacy-policy" target="_blank" rel="noreferrer">
                    Privacy
                  </a>
                  {' · '}
                  <a href="http://driveops.omnivatis.com/terms-of-use" target="_blank" rel="noreferrer">
                    Terms
                  </a>
                </p>
              )}
            </div>
            <IconChevron size={16} className="settings__chev" />
          </div>
        ))}
      </div>

      <button
        type="button"
        className="settings__logout"
        onClick={() => {
          dispatch(signOut())
          navigate('/login')
        }}
      >
        <IconLogout size={16} />
        {t('Déconnexion')}
      </button>
    </div>
  )
}
